import { render, staticRenderFns } from "./BlockchainSummary.vue?vue&type=template&id=58fe7c8e&scoped=true&"
import script from "./BlockchainSummary.vue?vue&type=script&lang=ts&"
export * from "./BlockchainSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fe7c8e",
  null
  
)

export default component.exports